"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListOrderAddressApprovalsForCheckInput = void 0;
const legacy_transformers_1 = require("@daytrip/legacy-transformers");
const class_validator_1 = require("class-validator");
const order_address_rejection_reason_enum_1 = require("../../../../../domain/booking/address-approval/enums/order-address-rejection-reason.enum");
class ListOrderAddressApprovalsForCheckInput {
}
exports.ListOrderAddressApprovalsForCheckInput = ListOrderAddressApprovalsForCheckInput;
__decorate([
    (0, class_validator_1.IsDate)(),
    legacy_transformers_1.TransformToDate,
    __metadata("design:type", Date)
], ListOrderAddressApprovalsForCheckInput.prototype, "startDepartureDate", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    legacy_transformers_1.TransformToDate,
    __metadata("design:type", Date)
], ListOrderAddressApprovalsForCheckInput.prototype, "endDepartureDate", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(order_address_rejection_reason_enum_1.OrderAddressRejectionReasonEnum, { each: true }),
    (0, class_validator_1.IsArray)(),
    __metadata("design:type", Array)
], ListOrderAddressApprovalsForCheckInput.prototype, "rejectionReasonIn", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(["departureAt", "email", "rejectionReason", "address", "positionType"]),
    __metadata("design:type", Object)
], ListOrderAddressApprovalsForCheckInput.prototype, "sortBy", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(["asc", "desc"]),
    __metadata("design:type", String)
], ListOrderAddressApprovalsForCheckInput.prototype, "sortDirection", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], ListOrderAddressApprovalsForCheckInput.prototype, "limit", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], ListOrderAddressApprovalsForCheckInput.prototype, "offset", void 0);
//# sourceMappingURL=ListOrderAddressApprovalsForCheckInput.js.map